import { Box, FormHelperText } from "@mui/material"
import type { FC } from "react"

import { AerosDatePicker } from "@/components/UiKit"
import { useDraftDateRange } from "@/hooks/useDraftDateRange"

interface DateRangeFilterProps {
  from: string | undefined
  to: string | undefined
  onRangeChange: (range: { from: string | undefined; to: string | undefined }) => void
  required?: boolean
  fromTestId: string
  toTestId: string
}

export const DateRangeFilter: FC<DateRangeFilterProps> = ({
  from,
  to,
  onRangeChange,
  required,
  fromTestId,
  toTestId,
}) => {
  const { fromDraft, toDraft, isRangeInvalid, handleFromChange, handleToChange } = useDraftDateRange({
    from,
    to,
    onRangeChange,
  })

  return (
    <Box className='flex-1 overflow-y-auto overflow-x-hidden px-8'>
      <Box className='flex flex-col gap-4 py-4'>
        <AerosDatePicker
          label='From'
          required={required}
          value={fromDraft ?? null}
          onChange={handleFromChange}
          error={isRangeInvalid}
          data-testid={fromTestId}
        />
        <AerosDatePicker
          label='To'
          required={required}
          value={toDraft ?? null}
          onChange={handleToChange}
          error={isRangeInvalid}
          data-testid={toTestId}
        />
        {isRangeInvalid && <FormHelperText error>From date must be on or before To date</FormHelperText>}
      </Box>
    </Box>
  )
}
